import { render, staticRenderFns } from "./LinkInfo.vue?vue&type=template&id=1ea80ea9&"
import script from "./LinkInfo.vue?vue&type=script&lang=js&"
export * from "./LinkInfo.vue?vue&type=script&lang=js&"
import style0 from "./LinkInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports